/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Input, notification } from "antd";
import { PrimaryButton } from "components/SuperAdminAndBusiness/PrimaryButton";
import { AuthContext } from "contexts/AuthContext";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { putUserByUuid } from "services/userService";

export const AdminPersonalInformationsProfileForm = () => {
  const [form] = Form.useForm();
  const { user } = useContext(AuthContext);
  const { t }: { t: (key: string) => string } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  const handleEditInformations = async () => {
    if (!user) {
      throw new Error("UserInfo are required");
    }

    try {
      setLoading(true);
      const name = form.getFieldValue("name");
      const email = form.getFieldValue("email");

      const userData = {
        name,
        email,
      };

      const response = await putUserByUuid(user.uuid as string, userData);
      if (response) {
        notification.success({
          placement: "bottomRight",
          message: t("informationsEditedSuccessfully"),
        });
      }
    } catch (error) {
      notification.error({
        placement: "bottomRight",
        message: t("errorEditingInformation"),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      name: user?.name,
      email: user?.email,
    });
  }, [user]);

  return (
    <Form
      form={form}
      layout="vertical"
      autoComplete="off"
      className="w-full flex flex-col gap-5 items-end"
      onFinish={handleEditInformations}
    >
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-3">
        <Form.Item
          name="name"
          label={<span className="font-bold">{t("name")}:</span>}
          rules={[{ required: true, message: t("thisFieldIsRequired") }]}
        >
          <Input
            id="name"
            placeholder={t("name")}
            className="rounded-md"
            size="large"
            allowClear
          />
        </Form.Item>

        <Form.Item
          name="email"
          label={<span className="font-bold">{t("email")}:</span>}
          rules={[
            { required: true, message: t("thisFieldIsRequired") },
            { type: "email", message: t("pleaseInputAValidEmail") },
          ]}
        >
          <Input
            id="email"
            placeholder={t("email")}
            className="rounded-md"
            size="large"
            allowClear
            type="email"
          />
        </Form.Item>
      </div>

      <PrimaryButton
        className="flex items-center justify-center"
        htmlType="submit"
        disabled={loading}
        loading={loading}
      >
        {t("editInformation")}
      </PrimaryButton>
    </Form>
  );
};
